export default "__VITE_ASSET__DxMSPcjR__"